import { Alert, Switch, Text, View } from 'react-native';
import { getDoc, setDoc, useDoc, useLiberacao, abasLiberadas } from '../../store/store';
import { Section } from '../../components/ui';
import { ABAS, C, alpha, useCores } from '../../components/theme';
import { addDays, brYmd, today } from '../../lib/date';
import { BotaoAcao } from '../../components/ajustes/Linhas';
import { t } from '../../lib/i18n';
import { cobrancaAtiva, DIAS_TESTE_ABA, MESES_TESTE_BASICO, PRECO_ABA_USD, PRECO_BASICO_USD, assinadaAte, precoTexto, type Situacao } from '../../lib/plano';
import { MODO_TESTE } from '../../lib/compras';
import { Assinar, AvisoAssinatura, GerenciarAssinaturas, usePrecos } from '../../components/Assinar';
import { moedaPadrao } from '../../lib/moeda';
import { Card, Linha } from './comum';

/** Ajustes > Compras: o plano atual e as abas que ainda podem ser compradas. */
export default function Compras(_: { cor: string }) {
  const aj = useDoc('ajustes');
  const lib = useLiberacao();
  const libAbas = abasLiberadas(lib);
  const { corDe, liberada, situacao } = useCores();
  const moeda = moedaPadrao();
  const txtSit = (s: Situacao) => s.tipo === 'liberada' ? (s.motivo === 'ilimitado' ? t('Acesso ilimitado') : s.motivo === 'suporte' ? t('Liberada pelo suporte') : s.motivo === 'lancamento' ? t('Grátis no lançamento') : t('Assinada'))
    : s.tipo === 'teste' ? t('Teste grátis até {data} ({n} dia(s))', { data: brYmd(s.ate), n: s.restam + 1 })
    : s.tipo === 'teste-disponivel' ? t('{n} dias grátis para testar', { n: DIAS_TESTE_ABA }) : t('Teste terminou em {data}', { data: brYmd(s.desde) });
  const txtDe = (id: any) => { const s = situacao(id); const a = s.tipo === 'liberada' && s.motivo === 'assinatura' ? ate(id) : null; return a ? t('Assinada, renova em {data}', { data: brYmd(a) }) : txtSit(s); };
  const basico = situacao('planner');
  const vencida = !!lib.validade && lib.validade < today();
  const pagas = ABAS.filter(x => !x.gratis);
  const aComprar = pagas.filter(x => !liberada(x.id));
  const minhas = pagas.filter(x => liberada(x.id));
  const precos = usePrecos(['planner', ...aComprar.map(x => x.id)]);
  const ate = (id: any) => assinadaAte(id, lib);

  return (<>
    <Section t={t('Meu plano')} />
    <Card>
      <Text style={{ color: C.text, fontWeight: '800' }}>📅 {t('Plano básico: My Planner + Anotações')}</Text>
      <Text style={{ color: basico.tipo === 'vencida' ? C.warn : C.sub, fontSize: 13 }}>{txtDe('planner')}</Text>
      {cobrancaAtiva() ? (<>
      <Text style={{ color: C.mute, fontSize: 12 }}>{t('{n} meses grátis a partir da criação da conta; depois {preco} por ano.', { n: MESES_TESTE_BASICO, preco: precos.planner || precoTexto(PRECO_BASICO_USD, moeda) })}</Text>
      {basico.tipo !== 'liberada' && <Assinar id="planner" cor={corDe('planner')} outline={basico.tipo === 'teste'} preco={precos.planner} />}
      <Text style={{ color: C.mute, fontSize: 12 }}>{t('Cada aba extra: {n} dias grátis; depois {preco} por ano.', { n: DIAS_TESTE_ABA, preco: precoTexto(PRECO_ABA_USD, moeda) })}</Text>
      </>) : <Text style={{ color: C.ok, fontSize: 13, fontWeight: '700' }}>🎉 {t('Nesta fase de lançamento, todas as abas estão liberadas e grátis.')}</Text>}
      {lib.ilimitado && (
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10, padding: 10, borderRadius: 12, backgroundColor: alpha(C.ok, 0.14) }}>
          <Text style={{ fontSize: 20 }}>♾️</Text>
          <Text style={{ color: C.ok, fontWeight: '800', flex: 1 }}>{t('Acesso ilimitado a todas as funções, sem prazo')}</Text>
        </View>
      )}
      <Linha l={t('Créditos')}><Text style={{ color: C.text, fontWeight: '800', fontSize: 16 }}>{lib.ilimitado ? t('Ilimitados') : lib.creditos}</Text></Linha>
      <View style={{ gap: 4 }}>
        <Text style={{ color: C.text }}>{t('Abas liberadas pelo suporte')}</Text>
        <Text style={{ color: vencida ? C.warn : C.sub, fontSize: 12 }}>
          {libAbas.length ? ABAS.filter(x => libAbas.includes(x.id)).map(x => `${x.icon} ${x.nome}`).join(' · ') : t('Nenhuma (plano gratuito)')}
          {!lib.ilimitado && lib.validade ? (vencida ? ' · ' + t('venceu em {data}', { data: brYmd(lib.validade) }) : ' · ' + t('até {data}', { data: brYmd(lib.validade) })) : ''}
        </Text>
      </View>
      {!!lib.observacao && <Text style={{ color: C.mute, fontSize: 12 }}>{lib.observacao}</Text>}
      <Text style={{ color: C.mute, fontSize: 11 }}>{t('Liberações e créditos são vinculados ao seu CPF. Atualiza ao sincronizar.')}</Text>
    </Card>
    {lib.teste && <ContaTeste cor={corDe('planner')} />}

    {cobrancaAtiva() && (<>
    <Section t={t('Abas para comprar')} />
    {!aComprar.length && <Card><Text style={{ color: C.sub }}>{t('Você já tem todas as abas.')} 🎉</Text></Card>}
    {aComprar.map(x => (
      <Card key={x.id}>
        <View style={{ flexDirection: 'row', gap: 12, alignItems: 'center' }}>
          <Text style={{ fontSize: 30 }}>{x.icon}</Text>
          <View style={{ flex: 1, gap: 2 }}>
            <Text style={{ color: C.text, fontWeight: '800', fontSize: 16 }}>{x.nome}</Text>
            <Text style={{ color: C.sub, fontSize: 12 }}>{x.desc}</Text>
            <Text style={{ color: situacao(x.id).tipo === 'vencida' ? C.warn : C.ok, fontSize: 12, fontWeight: '700' }}>{txtSit(situacao(x.id))}</Text>
          </View>
        </View>
        {MODO_TESTE ? (
        <Linha l={t('Assinar (simulação de teste)')}>
          <Switch value={!!aj.assinaturas[x.id]} trackColor={{ true: corDe(x.id) }}
            onValueChange={v => setDoc('ajustes', d => ({ ...d, assinaturas: { ...d.assinaturas, [x.id]: v } }))} />
        </Linha>) : <Assinar id={x.id} cor={corDe(x.id)} outline preco={precos[x.id]} />}
      </Card>
    ))}
    {MODO_TESTE ? <Text style={{ color: C.sub, fontSize: 12 }}>{t('Na versão das lojas, a compra será pela loja de apps do celular. Por enquanto a chave simula a assinatura para testes.')}</Text>
      : aComprar.length > 0 && <AvisoAssinatura />}

    </>)}
    {cobrancaAtiva() && minhas.length > 0 && (<>
      <Section t={t('Abas que você já tem')} />
      <Card>
        {minhas.map(x => (
          <Linha key={x.id} l={`${x.icon} ${x.nome}`}>
            {libAbas.includes(x.id) ? <Text style={{ color: C.ok, fontSize: 12 }}>{t('Liberada pelo suporte')}</Text> :
              MODO_TESTE ? <Switch value={!!aj.assinaturas[x.id]} trackColor={{ true: corDe(x.id) }}
                onValueChange={v => setDoc('ajustes', d => ({ ...d, assinaturas: { ...d.assinaturas, [x.id]: v } }))} />
              : <Text style={{ color: C.ok, fontSize: 12, flexShrink: 1, textAlign: 'right' }}>{txtDe(x.id)}</Text>}
          </Linha>
        ))}
        <Text style={{ color: C.sub, fontSize: 12 }}>{t('Ao cancelar, a aba fica em preto e branco e os vínculos somem das tarefas, mas nada é apagado.')}</Text>
      </Card>
    </>)}
    {cobrancaAtiva() && !MODO_TESTE && (<>
      <Section t={t('Assinaturas da loja')} />
      <Card><GerenciarAssinaturas cor={corDe('planner')} /></Card>
    </>)}
  </>);
}

/** 0.72 (texto 10 C10): ferramentas da conta de teste de compras (só aparecem nela; marcada no servidor pelo 47-CONTA-DE-TESTE.bat). */
function ContaTeste({ cor }: { cor: string }) {
  const recomecar = () => Alert.alert(t('Recomeçar os testes grátis?'), t('Todas as abas voltam a "{n} dias grátis para testar", como numa conta nova. As assinaturas simuladas são desligadas.', { n: DIAS_TESTE_ABA }), [
    { text: t('Cancelar'), style: 'cancel' },
    { text: t('Recomeçar'), onPress: () => setDoc('ajustes', d => ({ ...d, testes: {}, bonusAte: undefined, assinaturas: {} })) }]);
  const terminar = () => {
    const iniciados = Object.keys(getDoc('ajustes').testes ?? {}).filter(k => k !== 'basico');
    if (!iniciados.length) return Alert.alert(t('Nenhum teste começado'), t('Abra uma aba paga e comece o teste grátis. Depois volte aqui.'));
    const inicio = addDays(today(), -DIAS_TESTE_ABA);
    setDoc('ajustes', d => ({ ...d, bonusAte: undefined, testes: { ...d.testes, ...Object.fromEntries(iniciados.map(k => [k, inicio])) } }));
    Alert.alert(t('Pronto'), t('Os testes começados terminaram. Abra a aba para ver "O teste grátis terminou".'));
  };
  return (<>
    <Section t={'🧪 ' + t('Conta de teste de compras')} />
    <Card>
      <Text style={{ color: C.sub, fontSize: 12 }}>{t('Esta conta vê o app como uma conta nova, sem nenhuma aba liberada, para conferir os cadeados, o teste grátis e a compra. As outras contas não mudam.')}</Text>
      <BotaoAcao cor={cor} label={t('Recomeçar os testes grátis')} onPress={recomecar} />
      <BotaoAcao cor={cor} label={t('Fazer os testes terminarem agora')} onPress={terminar} />
    </Card>
  </>);
}
